<template>
    <div class="SocietyMatchesMatchContainer shadow" v-on:click="$emit('onSelect', match)">
        <div class="SocietyMatchesMatchContainer-img">
            <img :src="matchLogo(match.competizione)" alt="logo"/>
        </div>
        <div class="SocietyMatchesMatchContainer-info pl-2">
            <div class="text-uppercase">{{match.opponent}}</div>
            <div class="text-uppercase">Data: {{match.date | date}}</div>
            <div class="text-uppercase small mt-2">
                Date: <span class="text-success">{{match.start_request | date}}</span> -
                <span class="text-danger">{{match.end_request | date}}</span>
            </div>
            <div class="text-uppercase mt-2">
                Prezzo: {{match.price | currency}} - Min: {{match.tickets_threshold }} posti
            </div>
            <inter-button
                          size="small"
                          label="SELEZIONA"
                          @onClick="$emit('onSelect', match)">
            </inter-button>
        </div>
    </div>
</template>

<script>

    import Match from '@/models/Match';
    import InterButton from "../../../../components/form/inter-button/InterButton";
    import MatchService from "@/services/match-service";

    export default {
        name: "SocietyMatchesMatchContainer",
        components: {InterButton},
        props: {
            match: {
                type: Object,
                default: () => Object.assign({}, Match)
            },
            isSelected: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                srcLogo: require('@/assets/media/logo.svg'),
            }
        },
        methods: {
            matchLogo: function (competition) {
                return MatchService.getCompetitionLogo(competition)

            },
        }
    }
</script>

<style scoped>

</style>
